import React from 'react';
import styles from './BoxList.module.scss';
function BoxList({ ordered, children }) {
    if (ordered) {
        return React.createElement("ol", { className: styles.wrap }, children);
    }
    return React.createElement("ul", { className: styles.wrap }, children);
}
export default BoxList;
